<template>
  <div class="content-header">
    <div class="title-container">
      <div class="left-title">
        <SGPRowComponent>
          <SGPColComponent cols="5">
            <span class="page-title">
              {{ dadosFichaTecnica?.ctrl_tarefa?.map }} - {{ dadosFichaTecnica?.ctrl_tarefa?.tarefa }}
            </span>
          </SGPColComponent>
          
          <SGPColComponent cols="5">
            <SGPFormBotaoComponent
              round
              small
              :color="'#00818F'"
              style="margin: 3px;"
              @click="$emit('abrirModalAgendVisitaTecnica')"
            >
              <span class="text-white">Dados do Técnico</span>
            </SGPFormBotaoComponent>

            <SGPFormBotaoComponent
              round
              small
              v-if="circuito.solicitacao_cancelamento"
              :color="['primary', 'orange']"
              :key="alertaSolicitacaoCancelamento"
              style="margin: 3px;"
            >
              <span class="text-white">Aviso Cancelamento</span> 
            </SGPFormBotaoComponent>
            
            <SGPFormBotaoComponent
              round
              small
              :color="'#00818F'"
              v-if="circuito.ctrl_projeto_id"
              @click="$emit('abrirModalProjeto')"
              style="margin: 3px;"
            >
              <span class="text-white">{{ circuito.ctrl_projeto.projeto }}</span>
            </SGPFormBotaoComponent>

            <!-- <SGPFormBotaoComponent
              color="primary"              
              x-small
              fab
              v-if="circuito.solicitacao_mob"
              @click="$emit('abrirSolicitacaoMobilidade')"
              style="margin: 3px;"
            >
              <v-icon color="white">mdi-page-next-outline</v-icon>
            </SGPFormBotaoComponent> -->
          </SGPColComponent>

          <SGPColComponent cols="2">
            <!-- <SGPFormBotaoComponent
              color="orange"
              round  
              link      
              small
              :href="`/sgp/ficha-tecnica/${pcoTarefaId}`"
              style="margin: 3px;"
            >
              Ficha Tecnica
            </SGPFormBotaoComponent> -->

            <!-- <SGPFormBotaoComponent
              color="secondary"              
              x-small
              fab
              @click="$emit('abrirModalImage')"
              :disabled="!dadosFichaTecnica.ctrl_tarefa.url_file_processo"
              style="margin: 3px;"
            >
              <v-icon color="white">mdi-image</v-icon>
            </SGPFormBotaoComponent> -->
          </SGPColComponent>
        </SGPRowComponent>
      </div>
    </div>  
    
    <!-- INICIO BUTTONS-->
    <div class="buttons-container mt-3">
      <!-- <SGPFormBotaoComponent
        text
        @click="$emit('abrirModalChecklistAgendamento')"
        v-if="$permissionamento.possuiPermissao('gestao-producao.pco-check-agend-envio-email')"
      >
        <v-icon color="red">mdi-calendar-blank-outline</v-icon>
        <span>Checklist Agendamento</span>
      </SGPFormBotaoComponent>

      <SGPFormBotaoComponent  
        @click="$emit('abrirModalOrdemServico')"
        text      
        v-if="$permissionamento.possuiPermissao('gestao-producao.modos.aberturaDeOs')"
      >
        <v-icon color="red">mdi-format-list-checks</v-icon>
        <span>Modos</span>
      </SGPFormBotaoComponent> -->

      <!-- <SGPFormBotaoComponent 
        text 
        v-if="$permissionamento.possuiPermissao('gestao-producao.wf1.aberturaDeOsWf1')"
        @click="$emit('abrirModalWf1')"
      >
        <v-icon color="red">mdi-calendar-edit-outline</v-icon>
        <v-badge 
          v-if="dadosWf1PcoCircuito.length" 
          :content="dadosWf1PcoCircuito.length" 
          class="badge-anotacoes mb-7"
          style="position: absolute; left: 18px;"
        ></v-badge>
        <span>WF1</span>
      </SGPFormBotaoComponent> -->

      <!-- <SGPFormBotaoComponent  
        @click="$emit('abrirModalConsulta')"
        text      
        v-if="$permissionamento.possuiPermissao('gestao-producao.modos.aberturaDeOs')"
      >
        <v-icon color="red">mdi-account-search</v-icon>
        <span>Consulta</span>
      </SGPFormBotaoComponent>

      <SGPFormBotaoComponent
        text
        @click="$emit('abrirModalSemTratamento')"
        v-if="$permissionamento.possuiPermissao('gestao-producao.tratativas-sem-tratamento.listar')"
      >
        <v-icon color="red">mdi-format-list-checks</v-icon>
        <span>Atualização</span>
      </SGPFormBotaoComponent> -->

      <!-- <SGPFormBotaoComponent 
        v-if="listaDePcoCircuitoAnotacoes.length" 
        text 
        @click="$emit('abrirModalAnotacao')"
      >
        <v-icon color="red">mdi-format-list-checks</v-icon>    
        <v-badge 
          v-if="listaDePcoCircuitoAnotacoes.length" 
          :content="listaDePcoCircuitoAnotacoes.length" 
          class="badge-anotacoes mb-7"
          style="position: absolute; left: 18px;"
        ></v-badge>
        <span>Anotações</span>
      </SGPFormBotaoComponent> -->

      <SGPFormBotaoComponent 
        text 
        :link="true" 
        :to="getLinkFilaTarefas()"
      >
        <v-icon color="red">mdi-list-box-outline</v-icon>
        <span>Filas Tarefas</span>
      </SGPFormBotaoComponent>

      <!-- <SGPFormBotaoComponent 
        text 
        color="primary" 
        link 
        to="/sgp/filas-trabalho/5"
      >
        <v-icon color="primary">mdi-cursor-default-click-outline</v-icon>
        <span>Meus Atendimentos</span>
      </SGPFormBotaoComponent> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FichaTecnicaTarefaHeader',
  
  props: {
    dadosFichaTecnica: {
      type: Object,
      required: true
    },
    circuito: {
      type: Object,
      required: true
    },
    pcoTarefaId: {
      type: [String, Number],
      required: true
    },
    alertaSolicitacaoCancelamento: {
      type: Boolean,
      default: true
    }
  },
  
  methods: {
    getLinkFilaTarefas() {// 
      const link = `/workflow/filas-tarefas/${this.dadosFichaTecnica.ctrl_tarefa?.id}`;
      return link || '#';
    }
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  gap: 8px;

  .title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    width: 97%;
    gap: 8px;

    .left-title {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
    }
    
    .right-title {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: 500;
    font-family: Roboto;
    color: #666;
  }

  .buttons-container {
    display: flex;
    gap: 90;
  }
}
</style>
